import {
  Button,
  Col,
  Divider,
  notification,
  Popconfirm,
  Row,
  Space,
  Switch,
  Table,
} from "antd";
import moment from "moment/moment";
import React, { useEffect, useRef, useState } from "react";
import { withRouter } from "../../../../../../utils/tms-with-router/tms-with-router";
import {
  shopleaseAddtionalStates,
  shopLeaseCreationStates,
} from "../../../../../../constants/states-data.data";
import { DeleteOutlined } from "@ant-design/icons";
import tmsRouteMap from "../../../../../../constants/tms-route.map";
import useBuildingsStore from "../../../../../../zustand/buildings-and-shops.store";
import {
  BillAdjustment,
  BuildingBlockNoSelect,
  BuildingInstitutionSelect,
  BuildingSelect,
  LeaseInvoice,
  SortTypeAndBy,
} from "../../../../../../components/tms-customs/rents-and-leases";
import TmsModal from "../../../../../../components/tms-customs/tms-modal";
import PastInvoices from "../../../../../../components/tms-customs/rents-and-leases/past-invoices";

import { useReactToPrint } from "react-to-print";
import TmsExcelButton from "../../../../../../components/tms-customs/tms-excel-button";
const TmsSmBasLeaseList = ({ router }) => {
  const [tableCurrentPage, setTabelCurrentPage] = useState(1);
  const [tablePageSize, setTabelPageSize] = useState(10);
  const [sortType, setSortType] = useState("ASC");
  const [sortBy, setSortBy] = useState("createdAt");
  const [update, setUpdate] = useState("");
  const [editFlag, setEditFlag] = useState(false);
  const [editData, setEditData] = useState({});
  const [view, setView] = useState(false);
  const [adjustedAmount, setAdjustedAmount] = useState("");
  const [adjustedAmountRemarks, setAdjustedAmountRemarks] = useState("");
  const refContainer = useRef(null);
  const [pastTxnsFlag, setPastTxnFlag] = useState(false);

  const {
    selectedInstitution,
    loading,
    clearStates,
    fetchInstitutionList,
    fetchLandLeases,
    createdBuildingLeaseData,
    handleChangeStatus,
    selectedBlock,
    fetchCreatedBuildingsList,
    selectedBuilding,
    fetchBlocks,
    deleteLoading,
    handleArrearBillUpdate,
    fetchLeaseInvoices,
    deleteCreatedShopLease,
    excelLoading,
    handleExcelExport,
  } = useBuildingsStore();

  const handleTableChange = (pagination, filters, sorter) => {
    setTabelCurrentPage(pagination.current);
    setTabelPageSize(pagination.pageSize);
    if (sorter.field === "createdAt") {
      if (sorter.order === "ascend") {
        setSortType("ASC");
      } else if (sorter.order === "descend") {
        setSortType("DESC");
      }
    }
  };
  useEffect(() => {
    return () => {
      clearStates(shopLeaseCreationStates, shopleaseAddtionalStates);
    };
  }, []);

  useEffect(() => {
    router.location.pathname ===
      tmsRouteMap.sm_ral_buildings_buildings_lease_creation &&
      fetchInstitutionList(1, 200, "ASC", "createdAt", router);
  }, [router.location.pathname]);

  useEffect(() => {
    if (selectedInstitution && selectedInstitution !== "")
      fetchCreatedBuildingsList(1, 200, "ASC", "createdAt", router);
  }, [selectedInstitution]);

  useEffect(() => {
    if (
      selectedInstitution !== "" &&
      selectedInstitution &&
      selectedBuilding !== "" &&
      selectedBuilding
    ) {
      fetchBlocks(1, 200, "ASC", "createdAt", router);
    }
  }, [selectedInstitution, selectedBuilding]);

  useEffect(() => {
    if (selectedInstitution !== "" && selectedInstitution) {
      fetchLandLeases(
        tableCurrentPage,
        tablePageSize,
        sortType,
        sortBy,
        router
      );
    }
  }, [
    sortBy,
    tableCurrentPage,
    tablePageSize,
    sortType,
    selectedBlock,
    selectedBuilding,
    update,
    selectedInstitution,
  ]);

  const switchTrigger = async (record, status) => {
    await handleChangeStatus(record, status, router);
    setUpdate(Math.random() * 100000 + 21);
  };

  const handlePrint = useReactToPrint({
    content: () => refContainer.current,
    copyStyles: true,
    bodyClass: "tms-lease-container",
    onAfterPrint: () => {
      setView(false);
    },
  });

  return (
    <>
      <Row justify="flex-start" gutter={[20, 20]}>
        <BuildingInstitutionSelect span={5} />
        <BuildingSelect span={5} />
        <BuildingBlockNoSelect span={5} />
        <SortTypeAndBy
          span={4}
          sortBy={sortBy}
          sortType={sortType}
          setSortBy={setSortBy}
          setSortType={setSortType}
        />
        {selectedBuilding !== "" && selectedBuilding && (
          <Col style={{ padding: "0" }}>
            <p style={{ visibility: "hidden", paddingBottom: "4px" }}>
              Download
            </p>
            <TmsExcelButton
              loading={excelLoading}
              handleExcelExport={() => handleExcelExport("lease", router)}
              top={false}
            />
          </Col>
        )}
      </Row>

      <Table
        className={" accomadation_table captalise-center mt-10 "}
        tableLayout="fixed"
        scroll={{ x: "max-content" }}
        loading={loading}
        columns={[
          {
            title: "S.no",
            key: "sno",
            width: 70,
            render: (text, object, index) => index + 1,
          },
          {
            title: "Name of Lessee",
            dataIndex: "lesseName",
          },
          {
            title: "Address/Village",
            align: "center",
            render: (record) => `${record?.address}/${record?.village}`,
          },
          {
            title: "Building Name",
            dataIndex: "building",
            render: (record) => record?.buildingName,
          },

          {
            title: "Block Name",
            dataIndex: "blockOrFloor",
            render: (record) => record?.blockOrFloorName,
          },
          {
            title: "Shop Number",
            dataIndex: "shop",
            render: (record) => record?.shopNumber,
          },
          {
            title: "Extent(sft)",
            render: (record) =>
              `${record?.shopExtentLength}(L) x ${record?.shopExtentBreadth}(B)`,
          },
          {
            title: "Lease Period From & To",
            render: (record) =>
              `${moment(record?.leasePeriodStartDate).format(
                "DD-MM-YYYY"
              )} (to) ${moment(record?.leasePeriodEndDate).format(
                "DD-MM-YYYY"
              )}`,
          },
          { title: "Due Date", dataIndex: "dueDate" },

          { title: "paymentType", dataIndex: "paymentType" },
          {
            title: "Lessee type",
            dataIndex: "lesseType",
          },
          {
            title: "Lease Amount",
            dataIndex: "leaseRate",
            render: (record) => (record ? record : "0"),
          },
          {
            title: "Arrear Amount",
            dataIndex: "arrear",
            render: (record) => record?.arrearAmount,
          },
          {
            title: "Advance Amount",
            dataIndex: "depositAmount",
            render: (record) => (record ? record : "0"),
          },
          { title: "GST (%)", dataIndex: "gstPercentage" },
          {
            title: "Due Date",
            dataIndex: "dueDate",
          },
          {
            title: "Approval Status",
            dataIndex: "leaseApprovedByContemptoryOrders",
            render: (record) => (record ? "YES" : "NO"),
          },

          {
            title: "Status",
            key: "status",
            render: (record) => {
              return (
                <Switch
                  size={"small"}
                  checked={record?.status}
                  onClick={() => {
                    switchTrigger(record.id, !record.status);
                  }}
                />
              );
            },
          },
          {
            title: "Actions",
            key: "status",
            render: (record) => {
              return (
                <Space>
                  {/* {record.lastInvoiceGeneratedOn === null ? (
                    ""
                  ) : ( */}
                  <a
                    onClick={async () => {
                      try {
                        let records = await fetchLeaseInvoices(
                          record.id,
                          true,
                          1,
                          200,
                          "ASC",
                          "createdAt",
                          router
                        );
                        if (!records?.id) {
                          notification.error({
                            message: "No latest invoices are generated",
                          });
                          return;
                        } else {
                          setView(true);
                          setEditData(records);
                        }
                      } catch (e) {
                        setView(false);
                        notification.error({
                          message: "No latest invoices",
                        });
                        setEditData({});
                      }
                    }}
                  >
                    Invoice
                  </a>{" "}
                  <Divider type="vertical" />
                  <a
                    onClick={() => {
                      setEditData(record);
                      setPastTxnFlag(true);
                    }}
                  >
                    Invoice History
                  </a>
                  {/* )} */}
                  <Divider type="vertical" />
                  <a
                    onClick={() => {
                      setEditFlag(true);
                      setEditData(record);
                    }}
                  >
                    Bill Adjustment
                  </a>{" "}
                  <Divider type="vertical" />
                  <Space size="middle">
                    <Popconfirm
                      title="Are you sure delete this lease?"
                      onConfirm={async () => {
                        await deleteCreatedShopLease(record.id, router);
                        setUpdate(Math.random() * 100000 + 21);
                      }}
                      okText="Yes"
                      cancelText="No"
                      loading={deleteLoading}
                    >
                      <DeleteOutlined />
                    </Popconfirm>
                  </Space>{" "}
                </Space>
              );
            },
          },
        ].map((item) => {
          return { ...item, align: "center" };
        })}
        dataSource={
          createdBuildingLeaseData?.items?.map((item) => {
            return { key: item.id, ...item };
          }) ?? []
        }
        onChange={handleTableChange}
        pagination={{
          total: createdBuildingLeaseData?.meta?.totalItems ?? 0,
          current: tableCurrentPage,
          pageSize: tablePageSize,
        }}
        expandable={{
          expandedRowRender: (record) => {
            return (
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={record.eoProceedingUploadDocument}
              >
                {" "}
                Uploaded CAO Doc
              </a>
            );
          },
        }}
      ></Table>
      <TmsModal
        visible={view}
        width={"50%"}
        onOk={() => {
          setView(false);
          setEditData({});
        }}
        closable={true}
        centered
        onCancel={() => {
          setView(false);
          setEditData({});
        }}
      >
        <Row justify={"center"}>
          <Button onClick={handlePrint} type="primary">
            Print
          </Button>
        </Row>
        <br />
        <LeaseInvoice
          data={editData}
          refContainer={refContainer}
          type="shop-lease"
          scantype={"payment"}
        />
      </TmsModal>
      <BillAdjustment
        type="shop-lease"
        editFlag={editFlag}
        setEditFlag={setEditFlag}
        loading={loading}
        editData={{
          buildingName: editData?.building?.buildingName,
          blockName: editData?.blockOrFloor?.blockOrFloorName,
          shopNumber: editData?.shop?.shopNumber,
          lesseName: editData?.lesseName,
          lesseType: editData?.lesseType,
          leaseAmount: editData?.leaseRate,
          arrearAmount: editData?.arrear?.arrearAmount,
          arrearId: editData?.arrear?.id,
          shopLeaseId: editData?.id,
        }}
        setEditData={setEditData}
        adjustedAmount={adjustedAmount}
        setAdjustedAmount={setAdjustedAmount}
        adjustedAmountRemarks={adjustedAmountRemarks}
        setAdjustedAmountRemarks={setAdjustedAmountRemarks}
        handleArrearBillUpdate={handleArrearBillUpdate}
        setUpdate={setUpdate}
        router={router}
      />
      {pastTxnsFlag && (
        <PastInvoices
          type="shop-lease"
          pastTxnFlag={pastTxnsFlag}
          fetchLeaseInvoices={fetchLeaseInvoices}
          setPastTxnFlag={setPastTxnFlag}
          editData={editData}
          setEditData={setEditData}
          router={router}
        />
      )}
    </>
  );
};

export default withRouter(TmsSmBasLeaseList);
